/**
 * Validate if product is ready for date step
 */
export default defineNuxtRouteMiddleware(() => {});
